import { Spinner } from "react-bootstrap";


interface ILoading {
  className? : string
}
export default function Loading(props?: ILoading) {
  return (
    <div className={props?.className}>
      <div className='d-flex justify-content-center'>
        <Spinner animation="grow" variant="danger" size="sm" className='m-2' />
        <span className="visually-hidden">Loading...</span>

      </div>
    </div>
  )
}